var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#F7DF1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 17.3c0 .8.4 1.2 1.1 1.2.7 0 1.1-.4 1.1-1.5V9.8h1.9v7.4c0 1.7-1 2.5-2.6 2.5-1.4 0-2.2-.7-2.7-1.6l1.2-.8zM14.4 17.2c.4.7 1 1.2 2 1.2.8 0 1.3-.4 1.3-1 0-.7-.5-.9-1.5-1.3l-.5-.2c-1.5-.6-2.5-1.4-2.5-3 0-1.5 1.1-2.6 2.9-2.6 1.2 0 2.1.4 2.8 1.6l-1.5.9c-.3-.6-.7-.8-1.3-.8-.6 0-1 .4-1 .8 0 .6.4.9 1.3 1.3l.5.2c1.7.7 2.7 1.5 2.7 3.1 0 1.8-1.4 2.7-3.3 2.7-1.8 0-3-.9-3.6-2l1.7-1z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualJs);
export default __webpack_public_path__ + "static/media/manual-js.35b754f66625930089c37e524d7aae7a.svg";
export { ForwardRef as ReactComponent };